document.addEventListener("DOMContentLoaded", () => {
  var home_new_blogs = new Swiper(".home-new-blogs-containter", {
    lazy: true,
    slidesPerView: 2,
    spaceBetween: 24,
    navigation: {
      nextEl: ".cblog-next-btn",
      prevEl: ".cblog-prev-btn",
    },
    pagination: {
      el: ".home-collection-blog-new .swiper-pagination-new-home",
      clickable: true,
      container: ".home-new-blogs-content",
    },
    breakpoints: {
      320: {
        //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        //当屏幕宽度大于等于768
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1280: {
        //当屏幕宽度大于等于1280
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });
});
